module.exports = __webpack_public_path__ + "static/photogrammetry_process-30da01fa5c23fc78a19ef28b63a37156.jpg";